import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NkDirectivesModule } from '../../../../directives/directives';
import { NkPipesModule } from '../../../../pipes/pipes.module';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
  standalone: true,
  imports:[
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    NkDirectivesModule,
    NkPipesModule,
    ReactiveFormsModule,
    RouterModule,
  ]
})
export class NkContentComponent  {
  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
  }
}
